import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import { CAL_FACTOR_PRICE } from "Stores/actionTypes";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import StatusHandler from "Helpers/StatusHandler";

export default function PriceCalculation({ disabled }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { factorResult, selectedProject } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
    factorSetting: state.factor.factorSetting,
    selectedProject: state.project.selectedProject,
  }));
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      if (factorResult.ListUnitId.length > 0 || factorResult.CheckAll) {
        const data = {
          ...factorResult,
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
          TypeViewFactor: undefined,
          OnlyPrice: true,
        };
        const response = await FactorService.saveFactorPrice(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          dispatch({ type: CAL_FACTOR_PRICE, price: response.data.Value });
        }
      } else if (
        factorResult.ListUnitId.length === 0 &&
        !factorResult.CheckAll
      ) {
        showNotify({
          text: t("Please_select_the_desired_unit"),
          customClass: "error",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (factorResult.ListUnitId.length > 0)
      dispatch({ type: CAL_FACTOR_PRICE, price: null });
  }, [factorResult]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiButton
        loading={loading}
        color="primary"
        disabled={disabled}
        title={t("priceCalculation")}
        onClick={onClick}
      />
    </>
  );
}
